/**
 *
 * @module entry
 * @desc {SDK.Logging} entry point.
 *
 */

import LoggingApi from './loggingApi';
import Logger from './logger';
import LogEvent from './logEvent';
import LogSink from './logSink';
import LogLevel from './logLevel';
import Metric from './metric';
import ConsoleSink from './sinks/consoleSink';
import ConsoleSinkConfiguration from './consoleSinkConfiguration';
import LoggingClientConfiguration from './loggingClientConfiguration';

/**
 *
 * @desc default shared Logger instance
 * @note ConsoleSink is enabled by default
 *
 */
Logger.instance = (function () {

    const logger = new Logger();

    return logger;

}());

/**
 *
 * @typedef SDK.Logging
 * @type {Object}
 *
 * @property {LoggingApi} LoggingApi
 * @property {Logger} Logger
 * @property {LogEvent} LogEvent
 * @property {LogSink} LogSink
 * @property {LogLevel} LogLevel
 * @property {Metric} Metric
 * @property {ConsoleSinkConfiguration} ConsoleSinkConfiguration
 * @property {LoggingClientConfiguration} LoggingClientConfiguration
 *
 */

/**
 *
 * @type {SDK.Logging}
 *
 */
export default Object.assign(Logger.instance, {

    LoggingApi,
    Logger,
    LogEvent,
    LogSink: Object.assign(LogSink, {
        ConsoleSink
    }),
    LogLevel,
    Metric,
    ConsoleSinkConfiguration,
    LoggingClientConfiguration

});



// WEBPACK FOOTER //
// ./src/logging/entry.js